<label for="" class="rs-input-info" [formGroup]="mailboxIdForm">
  <div class="row collapse">
    <div class="rs-form-item">
      <div class="rs-flex-row rs-flex-collapse rs-flex-middle">
        <div class="rs-flex-column">
          <input
            type="text"
            name="mailId"
            id="mailId"
            formControlName="mailId"
            autocomplete="off"
            [ngClass]="{ 'rs-filled': !isMailEmpty() }"
          />
          <label class="rs-form-label" for="mailId">{{
            'create.mailbox.your.mailbox' | translate
          }}</label>
        </div>
        <div class="small-5 large-8 columns">
          <p class="rs-padding-top1">&nbsp;@{{ defaultMailboxDomain }}</p>
        </div>
      </div>
      <div
        class="row"
        *ngIf="
          mailboxIdForm.get('mailId').valid &&
          !mailboxIdForm.pending &&
          !mailboxIdForm.hasError('checkAlias') &&
          !mailboxIdForm.errors
        "
      >
        <div class="rs-form-helper">
          <ul>
            <li class="rs-form-success">
              {{ 'create.mailbox.available.title' | translate }}
            </li>
          </ul>
        </div>
      </div>
      <div
        class="row"
        *ngIf="
          mailboxIdForm.controls['mailId'].dirty &&
          !mailboxIdForm.pending &&
          (mailboxIdForm.errors || mailboxIdForm.controls['mailId'].errors)
        "
      >
        <div class="rs-form-helper">
          <ul>
            <li *ngIf="mailboxIdForm.hasError('checkAlias')" class="rs-form-error">
              {{ 'create.mailbox.not.available.title' | translate }}
            </li>
            <li *ngIf="mailboxIdForm.hasError('networkError')" class="rs-form-error">
              {{ 'mymail.app.error.network' | translate }}
            </li>
            <li *ngIf="mailboxIdForm.controls['mailId'].hasError('required')" class="rs-form-error">
              {{ 'create.mailbox.required.error' | translate }}
            </li>
            <li
              *ngIf="mailboxIdForm.controls['mailId'].hasError('minlength')"
              class="rs-form-error"
            >
              {{ 'create.mailbox.minimum.length.error' | translate }}
            </li>
            <li
              *ngIf="mailboxIdForm.controls['mailId'].hasError('maxlength')"
              class="rs-form-error"
            >
              {{ 'create.mailbox.maximum.length.error' | translate }}
            </li>
            <li
              *ngIf="
                (mailboxIdForm.controls['mailId'].hasError('pattern') ||
                  mailboxIdForm.hasError('pattern') ||
                  mailboxIdForm.controls['mailId'].hasError('whitespace') ||
                  mailboxIdForm.controls['mailId'].hasError('atSign')) &&
                mailboxIdForm.controls['mailId'].value.length >= 2
              "
              class="rs-form-error"
            >
              {{ 'create.mailbox.pattern.error' | translate }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</label>
